/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CtmsCategoryCreateReqVo
 */
export interface CtmsCategoryCreateReqVo {
    /**
     * 分类名称
     * @type {string}
     * @memberof CtmsCategoryCreateReqVo
     */
    categoryName: string;
    /**
     * 分类名称（英文）
     * @type {string}
     * @memberof CtmsCategoryCreateReqVo
     */
    categoryNameEn: string;
    /**
     * 分类名称(中文)
     * @type {string}
     * @memberof CtmsCategoryCreateReqVo
     */
    categoryNameCn: string;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof CtmsCategoryCreateReqVo
     */
    enable: number;
}

/**
 * Check if a given object implements the CtmsCategoryCreateReqVo interface.
 */
export function instanceOfCtmsCategoryCreateReqVo(value: object): value is CtmsCategoryCreateReqVo {
    if (!('categoryName' in value) || value['categoryName'] === undefined) return false;
    if (!('categoryNameEn' in value) || value['categoryNameEn'] === undefined) return false;
    if (!('categoryNameCn' in value) || value['categoryNameCn'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function CtmsCategoryCreateReqVoFromJSON(json: any): CtmsCategoryCreateReqVo {
    return CtmsCategoryCreateReqVoFromJSONTyped(json, false);
}

export function CtmsCategoryCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CtmsCategoryCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryName': json['categoryName'],
        'categoryNameEn': json['categoryNameEn'],
        'categoryNameCn': json['categoryNameCn'],
        'enable': json['enable'],
    };
}

export function CtmsCategoryCreateReqVoToJSON(json: any): CtmsCategoryCreateReqVo {
    return CtmsCategoryCreateReqVoToJSONTyped(json, false);
}

export function CtmsCategoryCreateReqVoToJSONTyped(value?: CtmsCategoryCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryName': value['categoryName'],
        'categoryNameEn': value['categoryNameEn'],
        'categoryNameCn': value['categoryNameCn'],
        'enable': value['enable'],
    };
}

